import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  checkboxGroup: {
    width: '100%',
    '.ant-checkbox': {
      '+span': {
        width: 'inherit'
      }
    }
  },

  cardRoot: {
    height: '100%'
  },

  cardBody: {
    padding: 0 + '!important',
    display: 'flex',
    height: '100%',
    alignItems: 'center'
  },

  checkbox: {
    padding: 12,
    width: '100%'
  }
}))
